import { CloseOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import { ReactElement } from 'react';
import { Button, Checkbox, Menu, Select, Tag, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { searchInPatientList, updateDropdownSearchFilter } from '../../../store/actions/inPatientAction';
import { RootState } from '../../../store';
interface IMultiselectCheckboxDropdown {
  placeholder: string;
  options: any[];
  value: any;
  ref?: any;
  reload?: any;
}

const MultiselectDropdownCheckbox = ({
  placeholder,
  options,
  value = [],
  reload,
}: IMultiselectCheckboxDropdown): ReactElement => {
  const { Option } = Select;
  const dispatch = useDispatch();
  const [arr, setArr] = useState<any>([]);
  const { centerIdList } =
    useSelector((state: RootState): any => state.selectedInPatientDetail || {});
  const [isCancel, setIsCancel] = useState(false);
  const [isOpen, setIsOpen] = useState(true);

  useEffect((): any => {
    if (centerIdList !== undefined) {
      setArr([...centerIdList]);
    }
  }, [centerIdList]);

  const onChange = (ele: any): any => {
    setIsCancel(true);
    setIsOpen(true);
  };

  const onSave = (): any => {
    dispatch(updateDropdownSearchFilter({ ['providerId']: arr }));
    dispatch(searchInPatientList());
  };
  const maxLength = 25;

  const onclick = (): any => {
    setIsOpen(true);
  };
  function tagRenderValues(tagProps: any): ReactElement {
    const { label: tagLabel , value: tagValue} = tagProps;
    return (
      <Tag className="tagRender group-center">
        <span>
         {tagLabel?.props?.children?.props?.children?.length > maxLength
          ? `${tagLabel?.props?.children?.props?.children.slice(0, maxLength)}...` : tagLabel?.props?.children?.props?.children}
          <span> {isOpen ? <CloseOutlined className="tagClose"
            onClick={(): any => {setIsCancel(true);
            clearCenter(tagValue); }} /> : <></>}</span>
        </span>
      </Tag>
    );
  }

  const onChangeCentre = (isSelected: boolean, ele: any): any => {
    setArr((prevArr: any): any => {

      const updatedArr = [...prevArr];
      if (isSelected) {

        updatedArr?.push(ele);
      } else {
        const index = updatedArr?.indexOf(ele);
        if (index !== -1) {
          updatedArr?.splice(index, 1);
        }
      }
      return updatedArr;
    });
  };

  const clearCenter = (ele: any): any => {
    arr.splice(0, 1);
    if (isOpen) {
    } else {
      dispatch(updateDropdownSearchFilter({ ['providerId']: arr }));
      dispatch(searchInPatientList());    }
    setArr((prevArr: any): any => {
      const updatedArr = [...prevArr];
      const index = updatedArr?.indexOf(ele);
        if (index !== -1) {
          updatedArr?.splice(index, 1);
        }
        return updatedArr;
      });
  };

  const clearAll = (): any => {
    setIsCancel(true);
    setArr([]);
  };
  const onCancel = (): any => {
    setIsOpen(false);
    if (centerIdList !== undefined) {
    setArr(centerIdList);
    } else {
      setArr([]);
    }
  };
  const clear = (): any => {
    dispatch(updateDropdownSearchFilter({ ['providerId']: [] }));
    dispatch(searchInPatientList());
  };
  return (
    <div>
      <Menu>
        <div>
          <Select
            mode="multiple"
            className={`multi-select-group w-100`}
            placeholder={placeholder}
            showSearch={true}
            value={isCancel ? arr : centerIdList}
            maxTagCount={1}
            allowClear={true}
            clearIcon={<CloseOutlined className={`${centerIdList?.length === 0 ?
            'hide-clear' : ''}`} onClick={clear}/>} // Customize clear icon
            onChange={onChange}
            onMouseEnter={onclick}
            tagRender={tagRenderValues}
            dropdownStyle = {{'visibility': !isOpen ? 'hidden' : 'visible'}}
            dropdownRender={(menu: any): any => (
              <div className="menu-class">
                {menu}
                <div className="bottom-menu">
                <a className="text-underline btn-link" onClick={clearAll}>Deselect All</a>
               <Button type="default" onClick={onCancel}>Cancel</Button>
                <Button type="primary"
                  onClick={onSave}>OK</Button>
                </div>
              </div>
            )}
            filterOption={(input: any, option: any): any => {
              const x = options?.filter((ele: any): any => ele?.key === option.key)[0]?.value;
              return (x?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0); // search center bugfixed
            }}
          >
            {
              options?.length > 0 && [
                ...options.map(({ providerName, key }: any): ReactElement => (
                  <Option key={key} value={key}><Checkbox checked={isCancel ? arr?.includes(key) : centerIdList?.includes(key)}
                    onChange={(event: any): any => onChangeCentre(event.target.checked, key)}>
                    <Tooltip title={providerName}>{providerName}</Tooltip></Checkbox></Option>
                ))]
            }
          </Select>
        </div>
      </Menu>
    </div>
  );
};

export default MultiselectDropdownCheckbox;
